// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

input {
    border-radius: 4px;
	padding: 3px 6px 2px;
}

select {
	height: 24px;
	padding: 3px 10px;
	border-radius: 5px;
}



input[type="checkbox"] {
	/* appearance: none; */
	/* background-color: white; */
	/* border: 1px solid #ccc; */
	/* color: red; */
	accent-color: #333; 
}

`, "",{"version":3,"sources":["webpack://./code/styles/inputs.css"],"names":[],"mappings":";;AAEA;IACI,kBAAkB;CACrB,oBAAoB;AACrB;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;AACnB;;;;AAIA;CACC,sBAAsB;CACtB,6BAA6B;CAC7B,4BAA4B;CAC5B,gBAAgB;CAChB,kBAAkB;AACnB","sourcesContent":["\n\ninput {\n    border-radius: 4px;\n\tpadding: 3px 6px 2px;\n}\n\nselect {\n\theight: 24px;\n\tpadding: 3px 10px;\n\tborder-radius: 5px;\n}\n\n\n\ninput[type=\"checkbox\"] {\n\t/* appearance: none; */\n\t/* background-color: white; */\n\t/* border: 1px solid #ccc; */\n\t/* color: red; */\n\taccent-color: #333; \n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
